import { Link } from "react-router-dom";
import { openCookieSettings } from "@/lib/consent";

export const LEGAL = {
  name: "MiniMellow",
  status: "Micro-entreprise de l'artisanat",
  siret: "987 620 614 00022",
  address: "[adresse à compléter]",
  email: "[adresse e-mail à compléter]",
  host: "Emergent — plateforme d'hébergement et de déploiement d'applications ([coordonnées complètes à compléter])",
};

export const LegalLayout = ({ eyebrow, title, updated = "octobre 2026", children, testId }) => (
  <div className="max-w-3xl mx-auto px-6 lg:px-10 py-14" data-testid={testId}>
    <p className="font-cursive text-2xl text-[#78353A]/70">{eyebrow}</p>
    <h1 className="font-cursive text-5xl md:text-6xl text-[#78353A] leading-none">{title}</h1>
    <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#4A3B32]/55">Dernière mise à jour : {updated}</p>
    <div className="legal mt-8 space-y-6 text-sm leading-relaxed text-[#4A3B32]/90">{children}</div>
    <nav className="mt-12 flex flex-wrap gap-x-5 gap-y-2 text-sm text-[#78353A]" aria-label="Pages légales">
      <Link to="/mentions-legales" className="underline decoration-dotted underline-offset-4">Mentions légales</Link>
      <Link to="/confidentialite" className="underline decoration-dotted underline-offset-4">Confidentialité & cookies</Link>
      <Link to="/cgv" className="underline decoration-dotted underline-offset-4">CGV</Link>
      <button type="button" onClick={openCookieSettings} className="underline decoration-dotted underline-offset-4" data-testid="legal-cookie-settings">Gérer mes cookies</button>
    </nav>
  </div>
);

export const H2 = ({ children }) => <h2 className="font-cursive text-3xl text-[#78353A] leading-none pt-2">{children}</h2>;
export const Todo = ({ children }) => <span className="rounded bg-[#FFF2B2] px-1.5 py-0.5 text-[#78353A]" data-testid="legal-todo">{children}</span>;
